export const moderationCases = [
  {
    id: 'mod-review-001',
    targetType: 'REVIEW',
    targetId: 'review-001',
    title: '원하는 느낌을 잘 이해해주셨고 현장도 깔끔하게 마무리됐어요.',
    owner: '하린팬',
    ownerType: 'MEMBER',
    source: '회원 후기',
    moderationStatus: 'PUBLISHED',
    submittedAt: '2026-08-10T17:42:00+09:00',
    reportCount: 0,
    relatedRoute: '/content/reviews/review-001',
    preview: '상담부터 설치까지 설명이 자세했고 원하는 분위기를 정확하게 반영해주셨어요. 사진도 함께 첨부했습니다.',
    attachments: ['review_001_01.jpg', 'review_001_02.jpg'],
    history: [
      { label: '후기 등록·공개', detail: '회원이 후기를 등록했고 즉시 공개되었습니다.', at: '2026. 08. 10. 17:42' },
    ],
  },
  {
    id: 'mod-review-002',
    targetType: 'REVIEW',
    targetId: 'review-002',
    title: '일정 안내가 조금 늦었습니다.',
    owner: '팬로그',
    ownerType: 'MEMBER',
    source: '회원 후기',
    moderationStatus: 'PUBLISHED',
    submittedAt: '2026-08-10T16:05:00+09:00',
    reportCount: 1,
    relatedRoute: '/content/reviews/review-002',
    preview: '진행 자체는 만족스러웠지만 일정 안내가 늦어 아쉬웠습니다.',
    attachments: ['review_002_01.jpg'],
    history: [
      { label: '후기 등록·공개', detail: '회원이 후기를 등록했고 즉시 공개되었습니다.', at: '2026. 08. 10. 15:40' },
      { label: '신고 접수', detail: '디렉터가 사실관계 확인을 요청했습니다. 신고만으로 자동 블라인드하지 않습니다.', at: '2026. 08. 10. 16:05' },
    ],
  },
  {
    id: 'mod-review-deleted-001',
    targetType: 'REVIEW',
    targetId: 'review-deleted-001',
    title: '친절하게 진행해주셔서 좋았습니다.',
    owner: '서포트데이',
    ownerType: 'MEMBER',
    source: '회원 후기',
    moderationStatus: 'DELETED',
    submittedAt: '2026-08-09T18:21:00+09:00',
    deletedAt: '2026-08-10T09:14:00+09:00',
    deletedBy: '서포트데이',
    deletedByType: 'MEMBER',
    reportCount: 0,
    relatedRoute: '',
    preview: '상담 답변이 빠르고 설치 시간도 잘 맞춰주셨어요.',
    attachments: ['review_deleted_01.jpg'],
    history: [
      { label: '후기 등록·공개', detail: '회원이 후기를 등록했고 즉시 공개되었습니다.', at: '2026. 08. 09. 18:21' },
      { label: '작성자 삭제', detail: '회원이 직접 삭제했습니다. DB에서는 soft delete 상태로 보존합니다.', at: '2026. 08. 10. 09:14' },
    ],
  },
  {
    id: 'mod-portfolio-001',
    targetType: 'PORTFOLIO',
    targetId: 'portfolio-001',
    title: '아이보리 플라워 생일 카페',
    owner: '스튜디오 빛결',
    ownerType: 'DIRECTOR',
    source: '디렉터 포트폴리오',
    moderationStatus: 'PUBLISHED',
    submittedAt: '2026-08-10T15:20:00+09:00',
    reportCount: 0,
    relatedRoute: '/content/portfolios/portfolio-001',
    preview: '아이보리와 샴페인 골드를 중심으로 구성한 생일 카페 공간 연출 포트폴리오입니다.',
    attachments: ['portfolio_001_cover.jpg', 'portfolio_001_02.jpg', 'portfolio_001_03.jpg'],
    history: [
      { label: '포트폴리오 등록·공개', detail: '디렉터가 공개 상태로 저장했고 즉시 사용자 화면에 노출되었습니다.', at: '2026. 08. 10. 15:20' },
    ],
  },
  {
    id: 'mod-portfolio-002',
    targetType: 'PORTFOLIO',
    targetId: 'portfolio-003',
    title: '도심 팝업 포토존',
    owner: '어라운드 데이',
    ownerType: 'DIRECTOR',
    source: '디렉터 포트폴리오',
    moderationStatus: 'HIDDEN',
    submittedAt: '2026-08-09T11:18:00+09:00',
    reportCount: 0,
    reason: '공개 권한 확인이 완료되지 않은 이미지가 포함되어 임시 블라인드했습니다.',
    relatedRoute: '/content/portfolios/portfolio-003',
    preview: '도심 소형 공간에 맞춘 팝업 포토존 사례.',
    attachments: ['portfolio_003_cover.jpg', 'portfolio_003_02.jpg'],
    history: [
      { label: '포트폴리오 등록·공개', detail: '디렉터가 공개 상태로 저장했습니다.', at: '2026. 08. 09. 11:18' },
      { label: '관리자 블라인드', detail: '공개 권한 확인 필요 · 김관리자', at: '2026. 08. 09. 13:02' },
    ],
  },
  {
    id: 'mod-portfolio-deleted-001',
    targetType: 'PORTFOLIO',
    targetId: 'portfolio-deleted-001',
    title: '화이트 팬미팅 웰컴존',
    owner: '메종 드 서포트',
    ownerType: 'DIRECTOR',
    source: '디렉터 포트폴리오',
    moderationStatus: 'DELETED',
    submittedAt: '2026-08-07T12:30:00+09:00',
    deletedAt: '2026-08-10T10:08:00+09:00',
    deletedBy: '메종 드 서포트',
    deletedByType: 'DIRECTOR',
    reportCount: 0,
    relatedRoute: '',
    preview: '화이트 플라워와 투명 아크릴 오브제를 활용한 팬미팅 웰컴존 포트폴리오입니다.',
    attachments: ['portfolio_deleted_cover.jpg', 'portfolio_deleted_02.jpg'],
    history: [
      { label: '포트폴리오 등록·공개', detail: '디렉터가 공개 상태로 저장했습니다.', at: '2026. 08. 07. 12:30' },
      { label: '작성자 삭제', detail: '디렉터가 직접 삭제했습니다. 사용자 화면에서는 즉시 비노출되고 DB에는 보존됩니다.', at: '2026. 08. 10. 10:08' },
    ],
  },
  {
    id: 'mod-director-media-001',
    targetType: 'DIRECTOR_MEDIA',
    targetId: 'director-001-media-03',
    title: '스튜디오 빛결 공개 사진 03',
    owner: '스튜디오 빛결',
    ownerType: 'DIRECTOR',
    source: '디렉터 공개 사진',
    moderationStatus: 'PUBLISHED',
    submittedAt: '2026-08-10T14:12:00+09:00',
    reportCount: 0,
    relatedRoute: '/directors/director-001',
    preview: '디렉터 공개 프로필의 사진 탭에 새로 등록한 현장 이미지입니다.',
    attachments: ['director_media_03.jpg'],
    history: [{ label: '사진 등록·공개', detail: '공개 사진 1장이 추가되어 즉시 노출되었습니다.', at: '2026. 08. 10. 14:12' }],
  },
  {
    id: 'mod-director-faq-001',
    targetType: 'DIRECTOR_FAQ',
    targetId: 'director-001-faq-03',
    title: '현장 설치는 몇 시간 전부터 가능한가요?',
    owner: '스튜디오 빛결',
    ownerType: 'DIRECTOR',
    source: '디렉터 FAQ',
    moderationStatus: 'PUBLISHED',
    submittedAt: '2026-08-10T13:30:00+09:00',
    reportCount: 0,
    relatedRoute: '/directors/director-001',
    preview: '행사장 규정에 따라 다르지만 일반적으로 행사 시작 2~4시간 전부터 설치를 진행합니다.',
    attachments: [],
    history: [{ label: 'FAQ 등록·공개', detail: '공개 프로필 FAQ가 추가되어 즉시 노출되었습니다.', at: '2026. 08. 10. 13:30' }],
  },
  {
    id: 'mod-director-profile-001',
    targetType: 'DIRECTOR_PROFILE',
    targetId: 'director-001-profile',
    title: '스튜디오 빛결 공개 프로필 변경',
    owner: '스튜디오 빛결',
    ownerType: 'DIRECTOR',
    source: '디렉터 공개 프로필',
    moderationStatus: 'PUBLISHED',
    submittedAt: '2026-08-08T10:20:00+09:00',
    reportCount: 0,
    relatedRoute: '/directors/director-001',
    preview: '생일 카페·공간 연출·플라워를 한 번에 설계하는 팬 서포트 디렉터',
    attachments: ['director_profile.jpg', 'director_cover.jpg'],
    history: [
      { label: '프로필 변경·공개', detail: '디렉터가 공개 프로필을 수정했고 즉시 반영되었습니다.', at: '2026. 08. 08. 10:20' },
    ],
  },
]

export const MODERATION_TYPE_LABELS = {
  REVIEW: '후기',
  PORTFOLIO: '포트폴리오',
  DIRECTOR_MEDIA: '디렉터 사진',
  DIRECTOR_FAQ: '디렉터 FAQ',
  DIRECTOR_PROFILE: '디렉터 프로필',
}
